import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";
import { ITag, ITagType } from "../models/settings.model";

@Injectable({ providedIn: 'root' })
export class ProjectTagService extends BaseService {
    private projectTagUrl = environment.apiUrl + '/project-tag';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getProjectTags(projectId: string) {
        return this.get<ITag[]>(this.projectTagUrl + '/project/' + projectId);
    }

    getProjectTagType(searchValue?: string) {
        return this.get<ITagType[]>(this.projectTagUrl + '/', { searchValue });
    }

    addUpdateProjectTagType(tagTypeIdsAdded: string[], tagTypeIdsRemoved: string[]) {
        return this.put<ITagType>(this.projectTagUrl + '/add-update-project-tag-type', { tagTypeIdsAdded, tagTypeIdsRemoved });
    }

    delinkProjectTagType(tagTypeId: string) {
        return this.put<ITagType>(this.projectTagUrl + '/delink-project-tag-type/' + tagTypeId, null);
    }

    getTagOptions(tagTypeIds: string[]) {
        return this.get<{ tagTypeId: string, name: string, tagId: string }[]>(this.projectTagUrl + '/tag-options', { tagTypeIds });
    }

    // tagsLinkedToTagType(tagTypes: ITagType[]) {
    //     return this.post<ITagType[]>(this.projectTagUrl + '/tags-linked-to-tag-type', { tagTypes: tagTypes });
    // }

    //might be used in future maybe 

    // createProjectTag(tagType: ITagType) {
    //     return this.post<ITag>(this.projectTagUrl + '/add-tag-type', tagType);
    // }

    // deleteProjectTag(tagId: string) {
    //     return this.delete(this.projectTagUrl + '/tag-type/' + tagId);
    // }

    // updateProjectTag(projectId: string, tagId: string, name: string) {
    //     return this.put<ITag>(this.projectTagUrl + '/update-tag-type', { projectId, tagId, name });
    // }


}